import React from "react"
import ReactDOM from "react-dom/client";
import {ErrorBoundary} from "@sentry/react";
import "./styles/main.scss";
import App from "@ui/components/App";
import store, {StoreContext} from "@ui/stores";
import LocaleProvider from "@ui/components/providers/LocaleProvider";
import UserProvider from "@ui/components/providers/UserProvider";
import DeviceTypeProvider from "@ui/components/providers/DeviceTypeProvider";

ReactDOM
  .createRoot(document.getElementById("root") as HTMLElement)
  .render(
    <StoreContext.Provider value={store}>
      <DeviceTypeProvider>
        <LocaleProvider>
          <UserProvider>
            <ErrorBoundary fallback={<p>Something went wrong!</p>}>
              <App/>
            </ErrorBoundary>
          </UserProvider>
        </LocaleProvider>
      </DeviceTypeProvider>
    </StoreContext.Provider>
  );
